import { FormControl, FormHelperText, InputLabel, OutlinedInput } from '@mui/material'
import { FunctionComponent, useEffect } from 'react'
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { IPostGoodCategory } from '../../../shared/services/good-category/good-category.model';
import GoodCategoryService from '../../../shared/services/good-category/good-category.service';
import { DialogWrapper } from '../../presentation-components/display-elements-components/dialog-wrapper';
import { TooltipButton } from '../../presentation-components/miscellaneous-components/tooltip-button';

export const GoodCategoryDialog: FunctionComponent<{
  goodCategoryId?: string,
  open: boolean,
  closeHandler: () => void,
  isEdit: boolean,
  isSubmitting: boolean,
  onSubmit: (values: IPostGoodCategory, restForm: () => void, isEdit: boolean) => void,
}> = ({
  goodCategoryId,
  open,
  closeHandler,
  isEdit,
  onSubmit,
  isSubmitting,
}) => {
    //Services
    const goodCategoryService = new GoodCategoryService()
    //Use Effects
    useEffect(() => {
      if (open && goodCategoryId) {
        goodCategoryService.getOne(goodCategoryId)
          .then(response => {
            formik.setFieldValue('category', response.category)
            formik.setFieldValue('subCategoryOne', response.subCategoryOne)
            formik.setFieldValue('subCategoryTwo', response.subCategoryTwo)
            formik.setFieldValue('goodCategoryReference', response.goodCategoryReference ? response.goodCategoryReference.split(',').join(', ') : null)
          })
          .catch(err => console.log(err))
      }
    }, [open])

    const goodCategorySchema = Yup.object().shape({
      category: Yup.string().required('You must provide a category name'),
      subCategoryOne: Yup.string().nullable(),
      subCategoryTwo: Yup.string().nullable(),
      goodCategoryReference: Yup.string().nullable(),
    })

    const formik = useFormik<IPostGoodCategory>({
      initialValues: {
        category: '',
        subCategoryOne: '',
        subCategoryTwo: '',
        goodCategoryReference: '',
      },
      validationSchema: goodCategorySchema,
      onSubmit: (values) => {
        if (values.subCategoryOne === '' || values.subCategoryOne === ' ') {
          values.subCategoryOne = null
        }
        if (values.subCategoryTwo === '' || values.subCategoryTwo === ' ') {
          values.subCategoryTwo = null
        }
        values.category = values.category.trim();
        if (values.subCategoryOne !== null) {
          values.subCategoryOne = values.subCategoryOne.trim()
        }
        if (values.subCategoryTwo !== null) {
          values.subCategoryTwo = values.subCategoryTwo.trim()
        }
        if (values.goodCategoryReference === '' || values.goodCategoryReference === ' ') {
          values.goodCategoryReference = null
        }
        onSubmit(values, formik.resetForm, isEdit)
      }
    })

    const cancelHandler = () => {
      formik.resetForm()
      closeHandler()
    }

    return (
      <DialogWrapper open={open} onClose={closeHandler} title={!isEdit ? 'Add Category' : 'Edit Category'} cancelHandler={cancelHandler} submitHandler={formik.submitForm} isSubmitting={isSubmitting}>
        <FormControl fullWidth sx={{ mt: 2 }}>
          <InputLabel>Category</InputLabel>
          <OutlinedInput id='category'
            name='category'
            label='category'
            fullWidth
            value={formik.values.category}
            onChange={formik.handleChange}
            error={formik.touched.category && Boolean(formik.errors.category)}
            sx={{
              mr: 2
            }}></OutlinedInput>
          {formik.touched.category && formik.errors.category &&
            <FormHelperText sx={{ color: "#bf3333", marginLeft: "16px !important" }}>
              {formik.errors.category ? <div>{formik.errors.category as string}</div> : null}
            </FormHelperText>
          }
        </FormControl>
        <FormControl fullWidth sx={{ mt: 2 }}>
          <InputLabel>Subcategory One</InputLabel>
          <OutlinedInput id='subCategoryOne'
            name='subCategoryOne'
            label='Subcategory One'
            fullWidth
            value={formik.values.subCategoryOne}
            onChange={formik.handleChange}
            error={formik.touched.subCategoryOne && Boolean(formik.errors.subCategoryOne)}
            sx={{
              mr: 2
            }}></OutlinedInput>
        </FormControl>
        <FormControl fullWidth sx={{ mt: 2 }}>
          <InputLabel>Subcategory Two</InputLabel>
          <OutlinedInput id='subCategoryTwo'
            name='subCategoryTwo'
            label='Subcategory Two'
            fullWidth
            value={formik.values.subCategoryTwo}
            onChange={formik.handleChange}
            error={formik.touched.subCategoryTwo && Boolean(formik.errors.subCategoryTwo)}
            sx={{
              mr: 2
            }}></OutlinedInput>
        </FormControl>
        <FormControl fullWidth sx={{ mt: 2 }}>
          <InputLabel>
            Product Category Reference
          </InputLabel>
          <OutlinedInput id='goodCategoryReference'
            name='goodCategoryReference'
            label='Product Category Reference'
            fullWidth
            value={formik.values.goodCategoryReference || ''}
            onChange={formik.handleChange}
            error={formik.touched.goodCategoryReference && Boolean(formik.errors.goodCategoryReference)}
            sx={{
              mr: 2
            }}></OutlinedInput>
        </FormControl>
      </DialogWrapper>
    )
  }